'use client'

import { useEffect, useState } from 'react'

type WindowSize = { width: number; height: number }

export function useWindowDimensions() {
    const [windowDimensions, setWindowDimensions] = useState<WindowSize | null>(null)

    useEffect(() => {
        const update = () => {
            setWindowDimensions({ width: window.innerWidth, height: window.innerHeight })
        }
        update()
        window.addEventListener('resize', update)
        return () => window.removeEventListener('resize', update)
    }, [])

    return windowDimensions
}
